import { eventBus } from '@/main.js'
import { Observable } from 'rxjs'
import authAPI from '@/services/auth/auth.api.service.js'
import api from '@/services/soccer/api.service.network.js'

export default {
  methods: {
    getWinningJackpot () {
      return Observable.create((observer) => {
        api.getBalance()

        api.getWinningJackpot().subscribe(
          data => {
            // data.Tickets.push({ JackpotName: 'Stadium JP Group', JackpotAmount: 1000.2, '// Barcode': '019283012938109823', LocationName: 'kodTest1' })
            // // eslint-disable-next-line standard/object-curly-even-spacing
            // data.Tickets.push({ JackpotName: 'Stadium JP Group', JackpotAmount: 10000.2, Barcode: '1o2i3p1o2i31po3i' })
            // // eslint-disable-next-line standard/object-curly-even-spacing
            // data.Tickets.push({ JackpotName: 'Stadium JP Group', JackpotAmount: 50000.2, Barcode: '1293819238012983019283' })
            // // eslint-disable-next-line standard/object-curly-even-spacing
            // data.Tickets.push({ JackpotName: 'Champion JP Location', JackpotAmount: 50000.2, Barcode: 'asdasdasd', LocationName: 'kodTest2' })
            // // eslint-disable-next-line standard/object-curly-even-spacing
            // data.Tickets.push({ JackpotName: 'Champion JP Location', JackpotAmount: 50000.2, Barcode: '1293819238012983019283' })
            // // eslint-disable-next-line standard/object-curly-even-spacing
            // data.Tickets.push({ JackpotName: 'Champion JP Group', JackpotAmount: 50000.2, Barcode: 'asdadad', LocationName: 'kodTest1' })
            if (data.Tickets.length > 0) {
              observer.next(this.getVideoJackpotByType(data))
            } else {
              observer.next({ 'isJackpotActive': false })
            }
            observer.complete()
          }, eventBus.onApiErrror)
      })
    },

    getVideoJackpotByType (jackpotData) {
      let isChampionJackpot = jackpotData.Tickets.filter(jackpot => jackpot.JackpotName === 'Champion JP Group' || jackpot.JackpotName === 'Champion JP Location')
      let isStadiumJackpot = jackpotData.Tickets.filter(jackpot => jackpot.JackpotName === 'Stadium JP Group' || jackpot.JackpotName === 'Stadium JP Location')
      let videoJackpotType = 0
      // TODO ZAJEDNICKI VIDEO TRAZITI
      let video = authAPI.getUrlForVSoccerStadiumJackpot()
      if (!isChampionJackpot.length > 0 && isStadiumJackpot.length > 0) {
        videoJackpotType = 1
      } else if (isChampionJackpot.length > 0 && !isStadiumJackpot.length > 0) {
        videoJackpotType = 2
        video = authAPI.getUrlForVSoccerChampionsJackpot()
      }
      return {
        'isJackpotActive': true,
        'videoLink': video,
        'videoJackpotType': videoJackpotType,
        'stadiumJackpot': isStadiumJackpot,
        'championJackpot': isChampionJackpot,
        'metadata': this.prepareMetaDataForJackpotVideo(videoJackpotType, isStadiumJackpot, isChampionJackpot)
      }
    },
    prepareMetaDataForJackpotVideo (videoJackpotType, stadiumJP, championJP) {
      let metaDataArray = []
      let jackpotData = []
      let waitingTime = 2
      let timeInterval = 0
      if (videoJackpotType === 1) {
        jackpotData = stadiumJP
      } else if (videoJackpotType === 2) {
        jackpotData = championJP
      } else {
        jackpotData = stadiumJP.concat(championJP)
        waitingTime = 3
      }
      timeInterval = (20 - waitingTime) / jackpotData.length
      for (let i = 0; i < jackpotData.length; i++) {
        metaDataArray.push({
          Time: waitingTime + timeInterval * i,
          Ticket: jackpotData[i],
          Type: videoJackpotType
        })
      }
      return metaDataArray
    }
  }
}
